'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _diacritics = require('diacritics');

var _Input2 = require('./Input');

var _Input3 = _interopRequireDefault(_Input2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fixValue(value) {
  if (!value) {
    return value;
  }

  // remove white spaces
  var valueChanged = value.replace(/\s/g, '');

  // remove diacritics
  valueChanged = (0, _diacritics.remove)(valueChanged);

  // to lowercase
  valueChanged = valueChanged.toLowerCase();

  return valueChanged;
}

var Word = function (_Input) {
  (0, _inherits3.default)(Word, _Input);

  function Word() {
    (0, _classCallCheck3.default)(this, Word);
    return (0, _possibleConstructorReturn3.default)(this, _Input.apply(this, arguments));
  }

  Word.prototype.onChange = function onChange(evn) {
    var target = evn.target;


    var fixedValue = fixValue(target.value);
    if (fixedValue !== target.value) {
      target.value = fixedValue;
    }

    _Input.prototype.onChange.call(this, evn);
  };

  return Word;
}(_Input3.default);

exports.default = Word;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/Word.js
 ** module id = 1284
 ** module chunks = 0
 **/